import React from "react";
import { useRouter } from "next/router";
import {
    SCALE_A,
    SCALE_B,
    NA_VALUE,
    NA_LABEL_IS,
    NA_LABEL_EN,
} from "../../data/diagnosticQuestions";
import styles from "./AnswerScale.module.scss";

export default function AnswerScale({ scaleType, value, onChange, color }) {
    const { locale } = useRouter();
    const scale = scaleType === "A" ? SCALE_A : SCALE_B;
    const labels = locale === "en" ? scale.labels_en : scale.labels_is;
    const naLabel = locale === "en" ? NA_LABEL_EN : NA_LABEL_IS;
    const isNaSelected = value === NA_VALUE;

    return (
        <div className={styles.scaleWrap}>
            <div
                className={`${styles.scaleRow} ${isNaSelected ? styles.dimmed : ""}`}
            >
                {labels.map((label, i) => {
                    const score = i + 1;
                    const isSelected = value === score;
                    return (
                        <button
                            key={score}
                            type="button"
                            className={`${styles.scaleOption} ${isSelected ? styles.selected : ""}`}
                            style={
                                isSelected
                                    ? {
                                          borderColor: color,
                                          backgroundColor: `${color}20`,
                                      }
                                    : {}
                            }
                            onClick={() => onChange(score)}
                            aria-label={`${label} (${score})`}
                        >
                            <span
                                className={styles.dot}
                                style={
                                    isSelected ? { backgroundColor: color } : {}
                                }
                            />
                            <span className={styles.label}>{label}</span>
                        </button>
                    );
                })}
            </div>
            <button
                type="button"
                className={`${styles.naOption} ${isNaSelected ? styles.naSelected : ""}`}
                onClick={() => onChange(isNaSelected ? null : NA_VALUE)}
                aria-pressed={isNaSelected}
            >
                {naLabel}
            </button>
        </div>
    );
}
